<template>
  <v-container>
    <v-layout column>
      <v-flex>
        <h1>Debugging</h1>
      </v-flex>
      <v-flex>
        <v-btn
          block
          color="red"
          :loading="removingServiceWorker"
          :disabled="removingServiceWorker"
          @click="removeServiceWorker"
        >
          Remove Service Worker
        </v-btn>
      </v-flex>
      <v-flex>
        <v-btn
          block
          color="red"
          :loading="purgingAppCaches"
          :disabled="purgingAppCaches"
          @click="purgeAppCaches"
        >
          Purge App Cache(s)
        </v-btn>
      </v-flex>
      <v-flex v-if="$auth.check('admin')">
        <h2>Send Test Email</h2>
        <v-text-field
          v-model="testEmailAddress"
          label="Recipient Address"
          :error-messages="testEmailAddressError"
        />
        <v-btn
          block
          @click="sendTestEmail"
        >
          Send Test Email
        </v-btn>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    removingServiceWorker: false,
    purgingAppCaches: false,

    testEmailAddress: '',
    testEmailAddressError: null
  }),
  methods: {
    removeServiceWorker () {
      if ('serviceWorker' in navigator) {
        this.removingServiceWorker = true
        navigator.serviceWorker.getRegistrations()
          .then((regs) => {
            for (let reg of regs) {
              reg.unregister()
            }
          })
          .catch(this.$root.apiErrorHandler())
          .finally(() => {
            this.removingServiceWorker = false
          })
      }
    },
    purgeAppCaches () {
      this.purgingAppCaches = true
      this.$root.swSendMessage('CACHE_PURGE')
        .catch(this.$root.apiErrorHandler())
        .finally(() => {
          this.purgingAppCaches = false
        })
    },
    sendTestEmail () {
      this.axios.post('/emails', {
        to: this.testEmailAddress
      })
        .then(() => {
          this.$root.msgType = 'success'
          this.$root.msgText = 'Email Sent'
          this.$root.showMsg = true
        })
        .catch(this.$root.apiErrorHandler((msg, errors) => {
          this.testEmailAddressError = errors.to
        }))
    }
  }
}
</script>
